import {
  FormControl,
  FormHelperText,
  Grid,
  Select,
  TextField,
  Typography
} from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import CustomButton from "../../../Components/CustomButton";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import Fonts from "../../../Config/Fonts";
import Icons from "../../../Config/Images";
import Strings from "../../../Config/Strings";
import { UploadMediaRequestAPI } from "../../../Store/Action/mediaAction";
import {
  updateProductQuantityAPI,
  updateProductsAPI,
} from "../../../Store/Action/productAction";
import { getLoggedInUserDetailsAPI } from "../../../Store/Action/UserAction";
import Colors from "../../../theme/Colors";
import { renderRequiredAsterisk } from "../../../Utils/helper";

const UpdateProducts = () => {
  const inputRef = useRef();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { product } = location?.state || {};

  const { userData } = useSelector((state) => state.user);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [imageSrc, setImageSrc] = useState("");

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/productList", text: "Products" },
      { key: "2", href: "/productList/edit", text: "Edit Product" },
    ]);
    dispatch(getLoggedInUserDetailsAPI({}));
  }, [dispatch]);

  useEffect(() => {
    if (userData?.data?.user_role_name === Strings.Manufactures) {
      setIsReadOnly(true);
    } else {
      setIsReadOnly(false);
    }
  }, [userData]);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      productName: product?.product_name,
      productDescription: product?.product_description,
      productCategory: product?.product_category_name,
      productGrossWeight: product?.product_gross_weight,
      productCode: product?.product_code,
      productLessWeight: product?.product_less_weight,
      productNetWeight: product?.product_net_weight,
    },
  });
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  const handleImageClick = useCallback(() => {
    inputRef.current.click();
  }, []);

  const handleImageChange = useCallback(
    (e) => {
      const files = e.target.files;
      const file = files[0];
      const newImageSrc = URL.createObjectURL(file);
      setImageSrc(newImageSrc); // Set the image URL for display

      const newProductImg = Array.from(files); // Convert FileList to array
      const isMultiple = newProductImg.length > 1;
      dispatch(
        UploadMediaRequestAPI(
          newProductImg,
          "files",
          isMultiple,
          (isSuccess, response) => {
            if (isSuccess?.status === true) {
              toast.success(response?.data?.message);
            } else {
              toast.error(response?.error?.message);
            }
          }
        )
      );
    },
    [dispatch] // Add 'dispatch' to dependency array
  );

  if (!product) {
    return <div>No product details available.</div>;
  }

  const onSubmit = async (data) => {
    const requestData = {
      product_id: product?.product_id,
      product_name: data?.productName,
      product_description: data?.productDescription,
      product_gross_weight: data?.productGrossWeight,
      product_less_weight: data?.productLessWeight,
      product_quantity: data?.productQuantity,
      product_price: data?.productPrice,
      product_code: data?.productCode,
      userId: userData?.data?.user_id,
    };

    const manufacturerRequestData = {
      product_id: product?.product_id,
      product_quantity: data?.productQuantity,
    };

    try {
      await dispatch(
        userData?.data?.user_role_name === Strings.Manufactures
          ? updateProductQuantityAPI(
              manufacturerRequestData,
              (isSuccess, response) => {
                if (isSuccess?.status === true) {
                  toast.success(response?.data?.message);
                  navigate("/productList");
                } else {
                  const errorMessage =
                    response?.error?.message || Strings.somethingWentWrongError;
                  toast.error(errorMessage);
                }
              }
            )
          : updateProductsAPI(requestData, (isSuccess, response) => {
              if (isSuccess?.status === true) {
                toast.success(response?.data?.message);
                navigate("/productList");
              } else {
                const errorMessage =
                  response?.error?.message || Strings.somethingWentWrongError;
                toast.error(errorMessage);
              }
            })
      );
    } catch (error) {
      console.log("add products api error=-=-=-=>>>>>:", error);
      toast.error(Strings.somethingWentWrongError);
    }
  };

  return (
    <div style={mainContainer}>
      <LeftSideNav />

      <div style={leftNavContainer}>
        <div style={topBar}>
          <TopNavBar leftSideText={"Edit Product"} />
          <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
        </div>

        <div style={tableContainer}>
          <form onSubmit={handleSubmit(onSubmit)} style={formStyle}>
            <Grid container spacing={3} xs={50}>
              <div
                style={{ width: "100%", display: "flex", marginTop: "35px" }}
              >
                <div
                  style={{
                    height: "100%",
                    width: "41%",
                    marginRight: 20,
                    borderRadius: "4px",
                    border: "1px dashed #D3D3D3",
                    cursor: "pointer",
                    display: "flex",
                    overflow: "hidden",
                    padding: 10,
                    marginLeft: "30px",
                  }}
                >
                  <div
                    onClick={handleImageClick}
                    style={{ width: "50%", height: "100%" }}
                  >
                    {imageSrc ? (
                      <img
                        src={imageSrc}
                        alt="Selected"
                        style={imageStyle}
                        loading="lazy"
                      />
                    ) : (
                      <div
                        style={{
                          flexDirection: "column",
                          border: "1px solid #D3D3D3",
                          marginRight: "10px",
                          height: "100%",
                          width: "95%",
                          borderRadius: "4px",
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex",
                        }}
                      >
                        <img
                          src={Icons.uploadImageIcon}
                          alt="Upload icon"
                          loading="lazy"
                          style={uploadIconStyle}
                        />
                        <input
                          Typography="file"
                          ref={inputRef}
                          multiple
                          style={{ display: "none" }}
                          onChange={(e) => handleImageChange(e)}
                        />
                      </div>
                    )}
                  </div>

                  <div
                    style={{
                      width: "50%",
                      height: "100%",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: "10px",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      {Array(6)
                        .fill("")
                        .map((_, index) => (
                          <div
                            key={index}
                            style={{
                              width: "100%",
                              height: "74px",
                              backgroundColor: Colors.white,
                              border: "1px solid #D3D3D3",
                              borderRadius: 4,
                              position: "relative", // Set position to relative for proper icon positioning
                              display: "flex", // Center the icon within the div
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {/* Add Plus Icon Here */}
                            <img
                              src={Icons.addImageIcon} // Ensure this is correctly defined or imported
                              alt="Add icon"
                              style={{ height: "24px", width: "24px" }}
                            />
                          </div>
                        ))}
                    </div>
                  </div>
                </div>

                <div style={{ width: "62%" }}>
                  <Grid item xs={45} sm={12}>
                    <Grid container spacing={0.9}>
                      <Grid container spacing={1.5} xs={38}>
                        <Grid item xs={4}>
                          <Typography
                            variant="subtitle1"
                            style={inputLabelFontStyle}
                          >
                            Brand {renderRequiredAsterisk("productBrandName")}
                          </Typography>
                          <Controller
                            name="productBrandName"
                            control={control}
                            render={({ field }) => (
                              <FormControl
                                fullWidth
                                error={!!errors.productBrandName}
                              >
                                <Select
                                  {...field}
                                  style={inputTextStyle}
                                  displayEmpty
                                  disabled={
                                    userData?.data?.user_role_name !==
                                    Strings.Admin
                                  }
                                  renderValue={(selected) => {
                                    if (!selected) {
                                      return <span>Select Product Brand</span>;
                                    }
                                    return selected;
                                  }}
                                  // onChange={handleBrandChange}
                                >
                                  {/* {brandData?.map((brand) => (
                              <MenuItem
                                key={brand.user_id}
                                value={brand.user_first_name}
                              >
                                {brand.user_first_name}
                              </MenuItem>
                            ))} */}
                                </Select>
                                <FormHelperText>
                                  {errors.productBrandName?.message}
                                </FormHelperText>
                              </FormControl>
                            )}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <Typography
                            variant="subtitle1"
                            style={inputLabelFontStyle}
                          >
                            Product Category{" "}
                            {renderRequiredAsterisk("productCategory")}
                          </Typography>
                          <Controller
                            name="productCategory"
                            control={control}
                            render={({ field }) => (
                              <FormControl
                                fullWidth
                                error={!!errors.productCategory}
                              >
                                <Select
                                  {...field}
                                  style={inputTextStyle}
                                  displayEmpty
                                  renderValue={(selected) => {
                                    if (!selected) {
                                      return (
                                        <span>Select Product Category</span>
                                      );
                                    }
                                    return selected;
                                  }}
                                >
                                  {/* {productCategoryData?.map((category) => (
                              <MenuItem
                                key={category.product_category_id}
                                value={category.product_category_name}
                              >
                                {category.product_category_name}
                              </MenuItem>
                            ))} */}
                                </Select>
                                <FormHelperText>
                                  {errors.productCategory?.message}
                                </FormHelperText>
                              </FormControl>
                            )}
                          />
                        </Grid>

                        <Grid item xs={4}>
                          <Typography
                            variant="subtitle1"
                            style={inputLabelFontStyle}
                          >
                            Product Sub-Category{" "}
                            {renderRequiredAsterisk("productSubCategory")}
                          </Typography>
                          <Controller
                            name="productSubCategory"
                            control={control}
                            render={({ field }) => (
                              <FormControl
                                fullWidth
                                error={!!errors.productSubCategory}
                              >
                                <Select
                                  {...field}
                                  style={inputTextStyle}
                                  displayEmpty
                                  renderValue={(selected) => {
                                    if (!selected) {
                                      return (
                                        <span>Select Product Sub Category</span>
                                      );
                                    }
                                    return selected;
                                  }}
                                >
                                  {/* {filteredSubCategories?.length > 0 ? (
                              filteredSubCategories.map((category) => (
                                <MenuItem
                                  key={category.product_category_id}
                                  value={category.product_category_name}
                                >
                                  {category.product_category_name}
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem disabled>
                                <span
                                  style={{
                                    fontSize: 14,
                                    fontWeight: "700",
                                    fontFamily: Fonts.Poppins,
                                    color: Colors.black,
                                  }}
                                >
                                  {Strings.NoDataFound}
                                </span>
                              </MenuItem>
                            )} */}
                                </Select>
                                <FormHelperText>
                                  {errors.productSubCategory?.message}
                                </FormHelperText>
                              </FormControl>
                            )}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid container spacing={0.5} style={{ marginTop: "5px" }}>
                      <Grid container spacing={1.5} xs={32}>
                        <Grid item xs={4}>
                          <Typography
                            variant="subtitle1"
                            style={inputLabelFontStyle}
                          >
                            Commission %{" "}
                            {renderRequiredAsterisk("productCommission")}
                          </Typography>
                          <Controller
                            name="productCommission"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                placeholder="Product Name"
                                variant="outlined"
                                fullWidth
                                error={!!errors.productCommission}
                                helperText={errors.productCommission?.message}
                                InputProps={{ style: inputTextStyle }}
                              />
                            )}
                          />
                        </Grid>

                        <Grid item xs={4}>
                          <Typography
                            variant="subtitle1"
                            style={inputLabelFontStyle}
                          >
                            Product Code {renderRequiredAsterisk("productCode")}
                          </Typography>
                          <Controller
                            name="productCode"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                placeholder="Product Code"
                                variant="outlined"
                                fullWidth
                                error={!!errors.productCode}
                                helperText={errors.productCode?.message}
                                InputProps={{
                                  style: inputTextStyle,
                                  readOnly: true,
                                }}
                              />
                            )}
                          />
                        </Grid>

                        <Grid item xs={4}>
                          <Typography
                            variant="subtitle1"
                            style={inputLabelFontStyle}
                          >
                            Product Name {renderRequiredAsterisk("productName")}
                          </Typography>
                          <Controller
                            name="productName"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                placeholder="Product Name"
                                variant="outlined"
                                fullWidth
                                error={!!errors.productName}
                                helperText={errors.productName?.message}
                                InputProps={{ style: inputTextStyle }}
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid container spacing={0.5} style={{ marginTop: "5px" }}>
                      <Grid container spacing={1.5} xs={32}>
                        <Grid item xs={4}>
                          <Typography
                            variant="subtitle1"
                            style={inputLabelFontStyle}
                          >
                            Product Metal{" "}
                            {renderRequiredAsterisk("productMetal")}
                          </Typography>
                          <Controller
                            name="productMetal"
                            control={control}
                            render={({ field }) => (
                              <FormControl
                                fullWidth
                                error={!!errors.productMetal}
                              >
                                <Select
                                  {...field}
                                  style={inputTextStyle}
                                  displayEmpty
                                  renderValue={(selected) => {
                                    if (!selected) {
                                      return <span>Select Product Metal</span>;
                                    }
                                    return selected;
                                  }}
                                >
                                  {/* {productMetalData?.map((category) => (
                              <MenuItem
                                key={category.product_metal_id}
                                value={category.product_metal_name}
                              >
                                {category.product_metal_name}
                              </MenuItem>
                            ))} */}
                                </Select>
                                <FormHelperText>
                                  {errors.productMetal?.message}
                                </FormHelperText>
                              </FormControl>
                            )}
                          />
                        </Grid>

                        <Grid item xs={4}>
                          <Typography
                            variant="subtitle1"
                            style={bottomHeadingTextStyle}
                          >
                            Stamp {renderRequiredAsterisk("productStamp")}
                          </Typography>
                          <Controller
                            name="productStamp"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                placeholder="Stamp"
                                fullWidth
                                variant="outlined"
                                error={!!errors.productStamp}
                                helperText={errors.productStamp?.message}
                                InputProps={{ style: inputTextStyle }}
                              />
                            )}
                          />
                        </Grid>

                        <Grid item xs={4}>
                          <Typography
                            variant="subtitle1"
                            style={bottomHeadingTextStyle}
                          >
                            Melting (Purity){" "}
                            {renderRequiredAsterisk("productMeltingPurity")}
                          </Typography>
                          <Controller
                            name="productMeltingPurity"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                placeholder="Product Melting"
                                variant="outlined"
                                fullWidth
                                error={!!errors.productMeltingPurity}
                                helperText={
                                  errors.productMeltingPurity?.message
                                }
                                InputProps={{ style: inputTextStyle }}
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </div>

              {/* Bottom Left: Gross, Less, and Net Weight */}
              <Grid
                container
                spacing={1}
                xs={40}
                style={{ marginLeft: "20px", marginTop: "8px" }}
              >
                <Grid item xs={2.4}>
                  <Typography
                    variant="subtitle1"
                    style={bottomHeadingTextStyle}
                  >
                    Gross Weight {renderRequiredAsterisk("grossWeight")}
                  </Typography>
                  <Controller
                    name="grossWeight"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        placeholder="Gross Weight"
                        variant="outlined"
                        fullWidth
                        error={!!errors.grossWeight}
                        helperText={errors.grossWeight?.message}
                        InputProps={{ style: inputTextStyle }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={2.4}>
                  <Typography
                    variant="subtitle1"
                    style={bottomHeadingTextStyle}
                  >
                    Less Weight {renderRequiredAsterisk("lessWeight")}
                  </Typography>
                  <Controller
                    name="lessWeight"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        placeholder="Less Weight"
                        variant="outlined"
                        fullWidth
                        error={!!errors.lessWeight}
                        helperText={errors.lessWeight?.message}
                        InputProps={{ style: inputTextStyle }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={2.4}>
                  <Typography
                    variant="subtitle1"
                    style={bottomHeadingTextStyle}
                  >
                    Net Weight
                  </Typography>
                  <Controller
                    name="netWeight"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        placeholder="Net Weight"
                        fullWidth
                        variant="outlined"
                        InputProps={{ style: inputTextStyle, disabled: true }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={2.4}>
                  <Typography
                    variant="subtitle1"
                    style={bottomHeadingTextStyle}
                  >
                    Quantity Pcs {renderRequiredAsterisk("productQuantity")}
                  </Typography>
                  <Controller
                    name="Quantity"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        placeholder="Product Quantity"
                        variant="outlined"
                        fullWidth
                        error={!!errors.Quantity}
                        helperText={errors.Quantity?.message}
                        InputProps={{ style: inputTextStyle }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={2.4}>
                  <Typography
                    variant="subtitle1"
                    style={bottomHeadingTextStyle}
                  >
                    HUID No. {renderRequiredAsterisk("productStamp")}
                  </Typography>
                  <Controller
                    name="productStamp"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        placeholder="Stamp"
                        variant="outlined"
                        error={!!errors.productStamp}
                        helperText={errors.productStamp?.message}
                        InputProps={{ style: inputTextStyle }}
                      />
                    )}
                  />
                </Grid>
              </Grid>

              {/* Bottom Left: Gross, Less, and Net Weight */}
              <Grid
                container
                spacing={1}
                xs={40}
                style={{ marginLeft: "20px", marginTop: "6px" }}
              >
                <Grid item xs={2.4}>
                  <Typography
                    variant="subtitle1"
                    style={bottomHeadingTextStyle}
                  >
                    Wastage for Retailer{" "}
                    {renderRequiredAsterisk("productWastageOfRetailer")}
                  </Typography>
                  <Controller
                    name="productWastageOfRetailer"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        placeholder="Wastage for Retailer"
                        variant="outlined"
                        InputProps={{ style: inputTextStyle }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={2.4}>
                  <Typography
                    variant="subtitle1"
                    style={bottomHeadingTextStyle}
                  >
                    Rate {renderRequiredAsterisk("retailerRate")}
                  </Typography>
                  <Controller
                    name="retailerRate"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        placeholder="Rate"
                        variant="outlined"
                        error={!!errors.retailerRate}
                        helperText={errors.retailerRate?.message}
                        InputProps={{ style: inputTextStyle, disabled: true }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={2.4}>
                  <Typography
                    variant="subtitle1"
                    style={bottomHeadingTextStyle}
                  >
                    Per Pcs Fine Retailers{" "}
                    {renderRequiredAsterisk("perPcsFineRetailer")}
                  </Typography>
                  <Controller
                    name="perPcsFineRetailer"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        placeholder="Per Pcs Fine Retailers"
                        variant="outlined"
                        error={!!errors.perPcsFineRetailer}
                        helperText={errors.perPcsFineRetailer?.message}
                        InputProps={{ style: inputTextStyle, disabled: true }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={2.4}>
                  <Typography
                    variant="subtitle1"
                    style={bottomHeadingTextStyle}
                  >
                    labour for Retailer{" "}
                    {renderRequiredAsterisk("labourRetailer")}
                  </Typography>
                  <Controller
                    name="labourRetailer"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        placeholder="labour Retailer"
                        variant="outlined"
                        error={!!errors.labourRetailer}
                        helperText={errors.labourRetailer?.message}
                        InputProps={{ style: inputTextStyle }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={2.4}>
                  <Typography
                    variant="subtitle1"
                    style={bottomHeadingTextStyle}
                  >
                    Minimum Qty Retailer{" "}
                    {renderRequiredAsterisk("minimumQtyRetailer")}
                  </Typography>
                  <Controller
                    name="minimumQuantityRetailer"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        placeholder="Minimum Quantity"
                        variant="outlined"
                        error={!!errors.minimumQuantityRetailer}
                        helperText={errors.minimumQuantityRetailer?.message}
                        InputProps={{ style: inputTextStyle }}
                      />
                    )}
                  />
                </Grid>
              </Grid>

              {/* Bottom Left: Gross, Less, and Net Weight */}
              <Grid
                container
                spacing={1}
                xs={40}
                style={{ marginLeft: "20px", marginTop: "6px" }}
              >
                <Grid item xs={2.4}>
                  <Typography
                    variant="subtitle1"
                    style={bottomHeadingTextStyle}
                  >
                    Wastage Wholesaler{" "}
                    {renderRequiredAsterisk("wastageWholesaler")}
                  </Typography>
                  <Controller
                    name="productWastageOfWholeSaler"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        placeholder="Wastage Wholesalers"
                        variant="outlined"
                        error={!!errors.productWastageOfWholeSaler}
                        helperText={errors.productWastageOfWholeSaler?.message}
                        InputProps={{ style: inputTextStyle }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={2.4}>
                  <Typography
                    variant="subtitle1"
                    style={bottomHeadingTextStyle}
                  >
                    Rate {renderRequiredAsterisk("wholesalerRate")}
                  </Typography>
                  <Controller
                    name="wholesalerRate"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        placeholder="Rate"
                        variant="outlined"
                        fullWidth
                        error={!!errors.wholesalerRate}
                        helperText={errors.wholesalerRate?.message}
                        InputProps={{ style: inputTextStyle, disabled: true }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={2.4}>
                  <Typography
                    variant="subtitle1"
                    style={bottomHeadingTextStyle}
                  >
                    Per Pcs Fine Wholesalers{" "}
                    {renderRequiredAsterisk("perPcsFineWholesaler")}
                  </Typography>
                  <Controller
                    name="perPcsFineWholeSaler"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        placeholder="Per Pcs Fine Retailers"
                        variant="outlined"
                        error={!!errors.perPcsFineWholeSaler}
                        helperText={errors.perPcsFineWholeSaler?.message}
                        InputProps={{ style: inputTextStyle, disabled: true }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={2.4}>
                  <Typography
                    variant="subtitle1"
                    style={bottomHeadingTextStyle}
                  >
                    labour Wholesaler{" "}
                    {renderRequiredAsterisk("labourWholesaler")}
                  </Typography>
                  <Controller
                    name="labourWholesaler"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        placeholder="labour Wholesalers"
                        variant="outlined"
                        error={!!errors.labourWholesaler}
                        helperText={errors.labourWholesaler?.message}
                        InputProps={{ style: inputTextStyle }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={2.4}>
                  <Typography
                    variant="subtitle1"
                    style={bottomHeadingTextStyle}
                  >
                    Minimum Qty Wholesaler{" "}
                    {renderRequiredAsterisk("minimumQtyWholesaler")}
                  </Typography>
                  <Controller
                    name="minimumQuantityWholeSaler"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        placeholder="Minimum Quantity"
                        variant="outlined"
                        fullWidth
                        error={!!errors.minimumQuantityWholeSaler}
                        helperText={errors.minimumQuantityWholeSaler?.message}
                        InputProps={{ style: inputTextStyle }}
                      />
                    )}
                  />
                </Grid>
              </Grid>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "100%" }}>
                  <Grid
                    container
                    spacing={1}
                    item
                    xs={10.5}
                    style={{ marginTop: "5px", marginLeft: "30px" }}
                  >
                    <Typography variant="subtitle1" style={inputLabelFontStyle}>
                      Product Description
                    </Typography>
                    <Controller
                      name="productDescription"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          placeholder="Product Description"
                          variant="outlined"
                          fullWidth
                          multiline
                          maxRows={2} // You can adjust this value to control the maximum number of rows visible
                          error={!!errors.productDescription}
                          helperText={errors.productDescription?.message}
                          InputProps={{
                            style: {
                              ...inputTextStyle,
                              overflow: "auto",
                            }, // Adjust maxHeight as needed
                          }}
                        />
                      )}
                    />
                  </Grid>
                </div>

                <div style={{ width: "50%" }}>
                  <CustomButton
                    handleSubmit={handleSubmit}
                    label={Strings.Save}
                  />
                </div>
              </div>
            </Grid>
          </form>
        </div>
      </div>
    </div>
  );
};

const mainContainer = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflowX: "hidden",
  overflowY: "hidden",
};

const leftNavContainer = {
  display: "grid",
  gridTemplateRows: "15% 80%",
  backgroundColor: Colors.bgColor,
};

const topBar = {
  height: "7vh",
  width: "100%",
};

const tableContainer = {
  width: "96%",
  height: '82vh',
  borderRadius: "6px",
  paddingLeft: "20px",
  paddingRight: "20px",
  marginLeft: "25px",
  backgroundColor: Colors.white
};

const formStyle = {
  padding: 0,
  margin: 0,
  marginTop: "10px",
  display: "flex",
  justifyContent: "flex-start",
};

const inputLabelFontStyle = {
  fontSize: 15,
  fontWeight: "600",
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  display: "flex",
  justifyContent: "flex-start",
  marginBottom: "5px",
};

const bottomHeadingTextStyle = {
  fontSize: 16,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.headingBlackColor,
  display: "flex",
  justifyContent: "flex-start",
  marginBottom: "5px",
};

const inputTextStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.Poppins,
  color: Colors.paginationTitle,
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  backgroundColor: Colors.white,
  textAlign: "start",
};

const imageStyle = {
  height: "98%",
  width: "94%",
  objectFit: "cover",
  border: "1px solid #D3D3D3",
  borderRadius: 4,
};

const uploadIconStyle = {
  height: "40px",
  width: "40px",
};

export default UpdateProducts;
